var _rect, _mask, _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStatusViewOnly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#188C7C",
    strokeDasharray: "2 2"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_2128_1956",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 21L21.5 9.75L10.25 21Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 21L21.5 9.75L10.25 21Z",
    fill: "#76808D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9571 21.7071L22.2071 10.4571L20.7929 9.04289L9.54289 20.2929L10.9571 21.7071ZM20.7929 9.04289L9.54289 20.2929L10.9571 21.7071L22.2071 10.4571L20.7929 9.04289Z",
    fill: "#76808D",
    mask: "url(#path-3-inside-1_2128_1956)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2128_1956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.15234 14.3756L13.2 21.7001L22.5973 9.68225",
    stroke: "#188C7C",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2128_1956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 13.5,
    fill: "white",
    transform: "translate(7.5 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusViewOnly);
export default __webpack_public_path__ + "static/media/StatusViewOnly.98d6135b4ee6dcf75cc9d42817c0f9e1.svg";
export { ForwardRef as ReactComponent };